__turbopack_context__.v({
  "active": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__active",
  "desktopWrapper": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__desktopWrapper",
  "label": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__label",
  "labelBox": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__labelBox",
  "mobileExhibitionWrapper": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__mobileExhibitionWrapper",
  "mobileLabel": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__mobileLabel",
  "mobileWrapper": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__mobileWrapper",
  "wrapper": "NavQuickLinkExhibitionsItem-module-scss-module__H7vQ3a__wrapper",
});
